// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__XygUq","overflowing":"ReadFullNote_overflowing__3KcKZ"};